module.exports = __webpack_public_path__ + "img/booking-image.4d9b81c3.png";